import React from 'react'

export function MobileSection({
  title,
  subtitle,
  children,
}: {
  title: string
  subtitle?: string
  children: React.ReactNode
}) {
  return (
    <section className="mobile-app__section">
      <h2 className="mobile-app__section-title">{title}</h2>
      {subtitle ? <p className="mobile-app__section-sub">{subtitle}</p> : null}
      {children}
    </section>
  )
}
